/* Ortak açığa çıkarma: [data-atl-reveal] taşıyan her öğe görünür alana
   girdiğinde bir kez yerine oturur. IntersectionObserver — kaydırma dinleyici
   yok, kare başına iş yok. Hareket azaltmada hiçbir şey gizlenmez. */
(() => {
  const kur = () => {
    const hedefler = document.querySelectorAll("[data-atl-reveal]:not([data-atl-seen])");
    if (!hedefler.length) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      hedefler.forEach((e) => e.setAttribute("data-atl-seen", "1"));
      return;
    }

    const g = new IntersectionObserver(
      (girisler) => {
        girisler.forEach((x) => {
          if (!x.isIntersecting) return;
          x.target.setAttribute("data-atl-seen", "1");
          g.unobserve(x.target);
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.12 }
    );
    hedefler.forEach((e) => g.observe(e));
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", kur, { once: true });
  else kur();
  document.addEventListener("shopify:section:load", kur);
})();
